class AutomaticDiscountPrices {
  api_endpoint = 'https://boncharge.io/=/api/getautomaticdiscount';

  context = {};
  numberFormat = {}
  discount = {};

  productListPriceWrapperSelector = '.card-wrapper:not(:has(a[href*="gift-card"],a[href*="membership"])) .card__content .card__information .card-information .price .price__container';
  productListPriceWrapperCollectionSelector = '.card-wrapper:not(:has(a[href*="gift-card"],a[href*="membership"])) .card__content .card__information .card-information .price[data-shipping-product-restrictions] .price__container';

  freeShippingFrom = 125;

  constructor(context, discount = null) {

    this.context = context;
    this.numberFormat = this.extractMoneyDetails(this.context.currency.number);

    if (!$) {
      console.log('AutomaticDiscountPrices: jQuery is missing');
      return false;
    }
    const _this = this;

    if (discount === null) {
      this.getAutomaticDiscount().then(data => {
        if (!data || !data.discount) {
          // nothing to do
        } else {
          _this.init(data.discount);
        }
      });
    } else {
      _this.init(discount);
    }
  }

  init(discount) {
    this.discount = discount;

    if (!this.discount) {
      return;
    }

    if (this.discount.title === 'LABORDAY26' || this.discount.title === 'BONCHARGE SALE') {
      const start = new Date('2026-08-03T15:00:00+08:00');
      const end = new Date('2026-09-13T23:59:59+08:00');
      const now = new Date();
      if (now >= start && now <= end) {
        //return;
      } else { return }
    }

    /* will be deleted */
    if (this.discount.hasOwnProperty('markets_only') && this.discount.markets_only.length > 0 && !this.discount.markets_only.includes(this.context.market)) {
      return;
    }
    /* will be deleted */

    const markets = this.discount?.markets ?? [];
    const marketsCondition = this.discount?.marketsCondition ?? 'include';
    if (markets.length && (marketsCondition === "include" && !markets.includes(this.context.market))) {
      return;
    }
    if (markets.length && (marketsCondition === "exclude" && markets.includes(this.context.market))) {
      return;
    }

    const acceptedTemplates = ['product', 'product.ux', 'product.pd-product'];
    if (acceptedTemplates.includes(this.context.template)) {
      this.initProduct();
    }
    this.initProductList();

    if (!this.discount.items.length) { // homepage collections
      this.addTag($('.collection-list-multicolumn').find('.media'));
      this.addTag($('.bestseller-product').find('.bestseller-product__card'));
    }

    this.initSlideCart();

    this.initSearchResults();

    /* TEMP */
    if (this.discount.title === 'LABORDAY26' || this.discount.title === 'BONCHARGE SALE') {
      const start = new Date('2026-09-03T15:00:00+08:00');
      const end = new Date('2026-09-13T23:59:59+08:00');
      const now = new Date();

      let isActive = now >= start && now <= end;

      if (this.discount.title === 'BONCHARGE SALE') {
        isActive = true;
      }
      if (isActive) {
        $('.hero-banner-new').addClass('hidden');
        //$('.twbs.collection-hero').addClass('hidden');
        $('.announcement-bar__message .sale-message').addClass('hidden');
        $('.lds-sale-banner').removeClass('hidden');
        $('.lds-sale-message').removeClass('hidden');

        // const announcementBarMessage = 'Labor Day Sale Ends Soon: 25% off sitewide';
        // $('.pd-announcement-bar__messages.hide-tablet-and-down').prepend(`
        // <div class="pd-announcement-bar__item">${announcementBarMessage}</div>
        // <span class="pd-announcement-bar__divider" style="color: #D81126;">|</span>
        // `);
        // const $mobileAnnouncementBar = $('.pd-announcement-bar__messages.hide-desktop-and-up');
        // const $mobileAnnouncementBarClone = $mobileAnnouncementBar.clone();
        // $mobileAnnouncementBarClone.insertAfter($mobileAnnouncementBar);
        // $mobileAnnouncementBar.remove();
        // $mobileAnnouncementBarClone.empty().prepend(`<div class="pd-announcement-bar__item"><p>${announcementBarMessage}</p></div>`).css({'transform': 'translateY(0)'});
        // $('.pd-announcement-bar').css({ '--color': '#fff', 'background': 'linear-gradient(45deg,rgba(21, 2, 4, 1) 0%, rgba(188, 7, 14, 1) 100%)'});

        /*
        document.addEventListener("DOMContentLoaded", function () {
          const $collectionHero = $('body[data-bch-template="collection.pillars-collection"] #MainContent .collection-hero, body[data-bch-template="collection.pillars-collection-sleep"] #MainContent .collection-hero, body[data-bch-template="collection.pillars-collection-skin"] #MainContent .collection-hero').css('padding', '1rem 0');
          const $bannerContainer = $collectionHero.find('.banner.container');
          $bannerContainer.css('display', 'none').first().css('display', 'block')
          $bannerContainer.children('div').css('background', 'none')
          $bannerContainer.find('.page-width, .py-5').removeClass('page-width py-5')
          $bannerContainer.find('h1, p').css('color', '#000');
        });
        */
        if (false && ['product', 'product.ux', 'product.pd-product'].includes(this.context.template)) {
          setTimeout(() => {
            const original = document.querySelector('#bchcdt bch-countdown-timer');
            let anchor = document.querySelector('.add-to-cart-items-wrapper');
            if (original && anchor) {
              const copy = document.createElement('bch-countdown-timer');
              copy.dataset.market = original.dataset.market;
              copy.className = original.className;
              copy.getRunningTimer = async () => false;
              copy.innerHTML = original.innerHTML;

              anchor.after(copy);

              copy.querySelector('.separator')?.remove();

              const src = original.querySelector('.bchcdt-countdown-wrapper');
              const dst = copy.querySelector('.bchcdt-countdown-wrapper');
                if (dst && src) {
                  setInterval(() => { dst.innerHTML = src.innerHTML; }, 1000);
                }
            }
          }, 2000);
        }
        if (location.pathname.startsWith("/collections/")) {
          setTimeout(() => {
            const style = document.createElement('style');
            style.textContent = '#product-grid > li:has(div.card__currently-unavailable) { display: none !important; }';
            document.head.appendChild(style);
          }, 1000);
        }
      }
    }
    /* TEMP */
  }

  initSlideCart() {
    const _this = this;
    const _init = function() {
      document.addEventListener('BchSlideCartLoaded', function () {
        setTimeout(function() {
          // const upsells = document.querySelector('.upsells');
          // new MutationObserver(() => _this.processSlideCart())
          //   .observe(upsells, { childList: true, subtree: true, characterData: true });
          _this.processSlideCart('loaded');
        }, 750);
      });
      document.addEventListener('BchSlideCartUpdated', function () {
        setTimeout(function() {
          _this.processSlideCart('updated');
        }, 850);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', _init);
    } else {
      _init();
    }
  }

  processSlideCart(event) {
    const _this = this;
    const $cart = $('#slidecarthq .slidecarthq');
    $cart.find('.upsells .upsell-item').each(function() {

      if ($(this).hasClass('upsells-dc-updated')) {
        return;
      }
      $(this).addClass('upsells-dc-updated');

      const $regularPrice = $(this).find('.upsell-text-prices');
      let regularPrice = $regularPrice.text();
      const currency_format_parts = _this.context.currency.format.split(/{{.*?}}/);
      currency_format_parts.forEach(format => {
        if (format) regularPrice = regularPrice.replace(format, '');
      });
      regularPrice = parseFloat(regularPrice
        .replace(_this.numberFormat.thousandSeparator, '')
        .replace(_this.numberFormat.decimalSeparator, '.')
        .replace(/\s/g, '')
        .trim()
      );
      const discountedPrice = (regularPrice * (1 - _this.discount.value)).toFixed(2);
      const discountedPriceMoney = _this.formatMoney(discountedPrice, '${{amount}}');

      let $target = $regularPrice.find('p');
      if (!$target.length) $target = $regularPrice;
      $target.html(`
        <span class="visually-hidden visually-hidden--inline">Regular price</span>
        <span><s class="price-item price-item--regular" aria-label="Regular price" style="text-decoration: line-through">${$regularPrice.text().trim()}</s></span>
        <span class="visually-hidden visually-hidden--inline">Sale price</span>
        <span class="price-item price-item--sale price-item--last" style="color:#de0526">${discountedPriceMoney}</span>
      `);
    });
  }

  initSearchResults() {
    const _this = this;
    const prior = window.BchSiteSearch && window.BchSiteSearch.lastResult;
    if (prior && Date.now() - prior.timestamp < 60000) {
      handle(prior);
    }
    window.addEventListener('bch:search-products-rendered', function (e) {
      handle(e.detail);
    });
    function handle(detail) {
      _this.processSearchResults(detail);
    }
  }

  processSearchResults(detail) {
    this.processProductList($('.bch-site-search__grid'));
  }

  initProduct() {
    const $priceWrapper = $('div[id^="price-template--"][id$="__main"]');

    const _this = this;

    if (!this.discount.items.length || (this.discount.items.length > 0 && $.inArray(this.context.handle, this.discount.items) > -1)) {
      if (!this.context.handle.includes("gift-card") && !this.context.handle.includes("membership")) {
        this.processProduct($priceWrapper);
        const priceChangeObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              _this.processProduct($(mutation.target));
            }
          });
        });
        priceChangeObserver.observe($priceWrapper[0], { childList: true });
      }
    }
    this.processProductList($('product-recommendations'));
    if ($('.ux-product-recommendations').length) {
      this.processProductList($('.ux-product-recommendations'));
    }

    const recommendedObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          recommendedObserver.disconnect();
          _this.processProductList($(mutation.target));
        }
      });
    });

    if($('section[id^="shopify-section-template--"][id$="__related-products"] product-recommendations')?.length) {
      recommendedObserver.observe($('section[id^="shopify-section-template--"][id$="__related-products"] product-recommendations')[0], { childList: true, subtree: true });
    }

    // const accessoriesObserver = new MutationObserver(function(mutations) {
    //   mutations.forEach(function(mutation) {
    //     if (mutation.type === 'childList') {
    //       accessoriesObserver.disconnect();
    //       _this.processProductAccessories();
    //     }
    //   });
    // });
    // accessoriesObserver.observe($('#product-accessories')[0], { childList: true, subtree: true });
    _this.processProductAccessories();

    _this.processAllDiscountElements();

  }

  processAllDiscountElements() {
    $('[data-discount-element]').each((index, element) => {

      if (!this.discount.items.length || this.discount?.items?.includes($(element)?.attr('data-discount-element'))) {
        if ($(element).hasClass('bch-has-discounted-price')) {
          return;
        }
        const discountElements = this.getDiscountElements($(element));
        $(element).html(discountElements);
      }
      // if (this.discount?.items?.includes($(element)?.attr('data-discount-element'))) {
      //   const discountElements = this.getDiscountElements($(element));
      //   $(element).html(discountElements);
      // }
    });
  }
  processAllDiscountElementsAuto() {
    setTimeout(() => {
      $('[data-discount-element-auto]').each((index, element) => {
        const discountElements = this.getDiscountElements($(element));
        $(element).html(discountElements);
      });
    });
  }

  processProduct($priceWrapper) {
    const $priceContainer = $priceWrapper.children('.price');
    const $salePrice = $priceContainer.find('.price__sale');
    const discountElements = this.getDiscountElements($priceContainer);

    $salePrice.html(discountElements);
    $('#bch-sticky-add-to-cart .pdp-sticky-add-to-cart__price').addClass('bch-has-discounted-price').html(discountElements);
    // $('#bch-sticky-add-to-cart > div > span').addClass('bch-has-discounted-price').html(discountElements);

    $priceContainer.addClass('bch-has-discounted-price');

    const discountPrices = this.getDiscountPrices($priceContainer);
    const hasFreeShipping = this.hasFreeShipping(discountPrices.now);
    if (!hasFreeShipping) {
      setTimeout(function() { $('#free-shipping-text, .ux-price__free-shipping').addClass('hidden'); }, 300);
    }

    this.addTag($('media-gallery'), true);
    this.addTag($('product-media-carousel'), true);

    const $bundleUpsaleContainer = $('.ux-bundle-product__price').find('.price');
    const $bundleUpsaleSalePrice = $bundleUpsaleContainer.find('.price__sale');
    const $bundleUpsaleSalePriceBadge = $bundleUpsaleContainer.find('.badge.price__badge-sale');
    if ($bundleUpsaleSalePriceBadge.length) {
      let discountBadgeDiscountCard = parseInt($bundleUpsaleSalePriceBadge.text().match(/\d+/)[0], 10);
      if (discountBadgeDiscountCard == 7) {
        discountBadgeDiscountCard = 6.66666666666667;
      }
      const discountText = this.calculateDiscountBadgePercent(discountBadgeDiscountCard, this.discount.value * 100);
      $bundleUpsaleSalePriceBadge.text(discountText + '% OFF');
      $('.ux-bundle-product__badge strong').text(discountText + '%');
    }
    $bundleUpsaleSalePrice.html(this.getDiscountElements($bundleUpsaleContainer));

    if (this.discount.title === 'BIOHACKER40' && this.discount.value == 0.37 && this.context.handle == 'biohackers-bundle') {
      $('.bundle-components-products .bch-discount40').each(function() {
        const $parentDiv = $(this).parent();
        $(this).removeClass('hidden');
        $parentDiv.find('.bch-price').addClass('hidden');
        $parentDiv.find('.bundle-save-percent').text('-40%');
      });
    }

  }

  processProductAccessories() {
    const $priceContainers = $('#product-accessories ul li, .pdp-best-paired-with__products .product-card-wrapper');
    const _this = this;
    $priceContainers.each(function() {
      const $priceContainer = $(this).find('.price .price__container');
      const handle = $(this).find('.product-accessories--product-title a').attr('data-product-handle');
      if (!_this.discount.items.length || (_this.discount.items.length > 0 && $.inArray(handle, _this.discount.items) > -1)) {
        const $salePrice = $priceContainer.find('.price__sale');
        const discountElements = _this.getDiscountElements($priceContainer);
        $salePrice.html(discountElements/*.replace(' ' + _this.context.currency.isoCode, '')*/);
        $priceContainer.addClass('bch-has-discounted-price');
      }
    });
  }

  initProductList() {


    this.processAllDiscountElementsAuto();

    //this.processProductList($('.bestseller-product__card'), '.price__container'); //HOMEPAGE

    this.processProductList($('.product-list-multicolumn')); //HOMEPAGE

    // this.processProductList($('.collection')); //HOMEPAGE
    this.processProductList($('.pd-product-carousel')); //HOMEPAGE

    this.processProductList($('.ux-pc')); //NEW PRODUCT GRID


    this.processProductList($('.megamenu-nav .megamenu__carousel.ux-pc__grid'), this.productListPriceWrapperCollectionSelector);

    if ($('.ux-product-recommendations').length) {
      this.processProductList($('.ux-product-recommendations'));
    }

    const $priceWrapper = $('#ProductGridContainer');
    if (!$priceWrapper.length) {
      return;
    }
    this.processProductList($priceWrapper);

    const _this = this;
    const productListObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && $('#gf-grid').find(_this.productListPriceWrapperCollectionSelector).length) {
          productListObserver.disconnect();
          _this.processProductList($(mutation.target), _this.productListPriceWrapperCollectionSelector);
        }
      });
    });
    productListObserver.observe($priceWrapper[0], { childList: true, subtree: true });
  }

  processProductList($priceWrapper, childSelector) {
    const priceContainerSelector = childSelector ?? this.productListPriceWrapperSelector;
    const _this = this;

    setTimeout(function(){
      $priceWrapper.find(priceContainerSelector).each(function() {
        const $priceContainer = $(this);
        const handle = _this.getProductHandleFromUrl(
          $priceContainer.parents('.card__information').find('.full-unstyled-link').attr('href')
        );
        if (!_this.discount.items.length || (_this.discount.items.length > 0 && $.inArray(handle, _this.discount.items) > -1)) {
          const $salePrice = $priceContainer.find('.price__sale');
          const discountElements = _this.getDiscountElements($priceContainer);
          $salePrice.html(discountElements);
          $priceContainer.addClass('bch-has-discounted-price');
          _this.addTag($priceContainer.parents('.card'), false, handle);
        }
      });
    }, 1000);
  }

  getProductHandleFromUrl(pathname) {
    const pathParts = pathname.split('/');
    if (pathParts.length >= 3 && pathParts[1] === 'products') {

      const index = pathParts[2].indexOf("?");
      return index === -1 ? pathParts[2] : pathParts[2].slice(0, index);

      // return pathParts[2];
    }
    return null;
  }

  calculateDiscountBadgePercent(beforePercent, afterPercent) {
    const percent = (100 - ((100 - beforePercent) / 100) * ((100 - afterPercent) / 100) * 100);
    return Math.floor(percent * 10) / 10;
  }

  addTag($tagContainer, isPdpTag = false, productListHandle = '') {
    let badge_auto_width = false;
    let discountText = (this.discount.value * 100) + '% OFF';
    if (isPdpTag && (this.context.handle.endsWith('-kit') || this.context.handle.endsWith('-bundle'))) {
      const $discountBadge = $('.badge.price__badge-sale.sale-discount-badge');
      if ($discountBadge.length) {
        let discountBadgeDiscount = parseInt($discountBadge.text().match(/\d+/)[0], 10);
        if (discountBadgeDiscount == 7) {
          discountBadgeDiscount = 6.66666666666667;
        }
        // if (discountBadgeDiscount == 7 || discountBadgeDiscount == 6) discountBadgeDiscount = 5;
        // discountText = ((this.discount.value * 100) + discountBadgeDiscount) + '% OFF';
        // discountText = '34% OFF';
        discountText = this.calculateDiscountBadgePercent(discountBadgeDiscount, this.discount.value * 100) + '% OFF';

        // $discountBadge.remove();
        $discountBadge.hide();
      }
      badge_auto_width = true;
    }

    /* TEMP */
    // if ((productListHandle.endsWith('-kit') || productListHandle.endsWith('-bundle'))) {
    //   discountText = '30% OFF';
    // }
    /* TEMP */

    // if (false && productListHandle && productListHandle === 'red-light-cap') {
    //   discountText = 'Pre-Order: ' + discountText;
    //   badge_auto_width = true;
    // }
    if ($tagContainer.find('.card__badge').length) {
      const $discountBadgeCard = $tagContainer.find('.badge.discount-badge');
      if ($discountBadgeCard.length) {
        let discountBadgeDiscountCard = parseInt($discountBadgeCard.text().match(/\d+/)[0], 10);

        // discountText = ((this.discount.value * 100) + discountBadgeDiscountCard) + '% OFF';
        // discountText = calculateDiscountBadgePercent(6.67, this.discount.value * 100) + '% OFF';

        if (discountBadgeDiscountCard == 7) {
          discountBadgeDiscountCard = 6.66666666666667;
        }

        discountText = this.calculateDiscountBadgePercent(discountBadgeDiscountCard, this.discount.value * 100) + '% OFF';
        $discountBadgeCard.remove();
      }
      $tagContainer.find('.card__badge').addClass('with-has-discounted-price-tag');
    }

    const _productHandle = isPdpTag ? this.context.handle : productListHandle;
    if (this.discount.title === 'BIOHACKER40' && this.discount.value == 0.37 && _productHandle == 'biohackers-bundle') {
      discountText = '40% OFF';
    }
    $tagContainer.append('<div class="bch-has-discounted-price-tag"' + (badge_auto_width ? ' style="width:auto"':'') + '>' + discountText + '</div>');
  }

  getDiscountElements($priceContainer) {
    let $regularPrice = $priceContainer.find('.price__regular .price-item.price-item--regular');
    let regularPrice = $regularPrice.text();
    const $regularPriceSale = $priceContainer.find('.price__sale .price-item.price-item--regular');

    if ($regularPriceSale.length && $regularPriceSale.text().trim()) {
      $regularPrice = $regularPriceSale;
    }
    const currency_format_parts = this.context.currency.format.split(/{{.*?}}/);
    currency_format_parts.forEach(format => {
      if (format) regularPrice = regularPrice.replace(format, '');
    });

    regularPrice = parseFloat(regularPrice
      .replace(this.numberFormat.thousandSeparator, '')
      .replace(this.numberFormat.decimalSeparator, '.')
      .replace(/\s/g, '')
      .trim()
    );
    const discountedPrice = (regularPrice * (1 - this.discount.value)).toFixed(2);
    const discountedPriceMoney = this.formatMoney(discountedPrice);
    return `
      <span class="visually-hidden visually-hidden--inline">Regular price</span>
      <span><s class="price-item price-item--regular" aria-label="Regular price">${$regularPrice.text().trim()}</s></span>
      <span class="visually-hidden visually-hidden--inline">Sale price</span>
      <span class="price-item price-item--sale price-item--last">${discountedPriceMoney}</span>
    `;
  }

  getDiscountPrices($priceContainer) {
    let regularPrice = $priceContainer.find('.price__regular .price-item.price-item--regular').text();

    const currency_format_parts = this.context.currency.format.split(/{{.*?}}/);
    currency_format_parts.forEach(format => {
      if (format) regularPrice = regularPrice.replace(format, '');
    });

    regularPrice = parseFloat(regularPrice
      .replace(this.numberFormat.thousandSeparator, '')
      .replace(this.numberFormat.decimalSeparator, '.')
      .replace(/\s/g, '')
      .trim()
    );
    const discountedPrice = (regularPrice * (1 - this.discount.value)); //.toFixed(2);

    return { was: regularPrice, now: discountedPrice };
  }

  async getAutomaticDiscount() {
    // window.bchFetchApi (snippets/bch-automatic-discount-prices.liquid) falls back to fly.io
    const request = window.bchFetchApi
      ? window.bchFetchApi(this.api_endpoint)
      : fetch(this.api_endpoint, { method: "GET" }).then((response) => response.json());
    return await request.catch((e) => {
      console.error(e);
      return false;
    });
  }

  formatMoney(cents, format) {
    let money_format = this.context.currency.format;
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    let value = '',
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = (format || money_format);

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }
      number = (number/100.0).toFixed(precision);
      let parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, this.numberFormat.thousandSeparator, this.numberFormat.decimalSeparator);
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, this.numberFormat.thousandSeparator, this.numberFormat.decimalSeparator);
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", this.numberFormat.decimalSeparator);
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  extractMoneyDetails(moneyString) {
    let thousandSeparator = null;
    let decimalSeparator = null;
    const cleanedStringForSeparators = moneyString.replace(/[^0-9.,]/g, '');
    const potentialSeparators = (cleanedStringForSeparators.match(/[.,]/g) || []);

    if (potentialSeparators.length === 0) {
      return { thousandSeparator: null, decimalSeparator: null };
    }
    const matchDecimal = cleanedStringForSeparators.match(/([.,])(\d{1,2})$/);
    if (matchDecimal) {
      decimalSeparator = matchDecimal[1];
      const otherSeparatorCandidates = potentialSeparators.filter(sep => sep !== decimalSeparator);
      if (otherSeparatorCandidates.length > 0) {
        thousandSeparator = otherSeparatorCandidates[0];
      }
    } else {
      if (potentialSeparators.length > 0) {
        if (potentialSeparators.every(sep => sep === potentialSeparators[0])) {
          thousandSeparator = potentialSeparators[0];
        }
      }
    }
    return { thousandSeparator, decimalSeparator };
  }

  hasFreeShipping(price) {
    let freeShippingFrom = this.freeShippingFrom * this.context.currency.rate;
    if (this.context.currency.isoCode !== this.context.currency.default && (this.context.currency.currency_iso in this.context.free_shipping_from)) {
      freeShippingFrom = this.context.free_shipping_from[this.context.currency.isoCode];
    }
    return price >= freeShippingFrom;
  }
}

